<template>
    <div class="h-100 d-flex flex-column justify-content-center">
        <b>{{ formatingDateOrTime(today, dateFormat) }}</b>
        <span class="fw-semibold">
            {{ formatingDateOrTime(today, timeFormat) }}
            {{ timeZone }}
        </span>
    </div>
</template>

<script lang="ts" src="./DateTime.ts"></script>
